// Шкала Влияния Деуса (А.4.4.1, диздок 6.X).
// Диапазон 0..10. Излишки логируются как «не учтены».
// Стартовое значение 0 — устанавливается в Player.constructor.

import { shortHeroName } from '../../../data/heroes.js';
import { recomputeDirectorAura } from './vtoroy-direktor.js';

export const INFLUENCE_MAX = 10;

// Прибавить amount Влияния игроку playerIdx.
// Только Деус имеет шкалу — остальные фракции игнорируют.
// sourceName — короткое имя источника для лога (например, 'Никоси', 'Аналитик').
// А.4.4.3: после Манипуляции на 1 ход блокируется получение Влияния.
export function addInfluence(state, playerIdx, amount, sourceName = '') {
  if (amount <= 0) return;
  const p = state.players[playerIdx];
  if (!p || p.hero.faction !== 'deus') return;
  // Блокировка после Манипуляции (если активна на текущий ход).
  if (p.blockInfluenceUntilTurn != null && state.currentTurn <= p.blockInfluenceUntilTurn) {
    state.log.add(`✨ ${shortHeroName(p.hero)} [${p.name}]: Манипуляция — Влияние +${amount} не учтено в этот ход${sourceName ? ` — ${sourceName}` : ''}`);
    return;
  }
  // Этап 56.49-фикс: кап = базовый 10 + бонус от «Тайный совет» (influenceMaxBonus).
  // Раньше использовалась голая константа INFLUENCE_MAX → Тайный совет (+2 макс)
  // не работал, Влияние всё равно упиралось в 10.
  const cap = INFLUENCE_MAX + (p.influenceMaxBonus || 0);
  const before = p.influence;
  const after = Math.min(cap, before + amount);
  const actual = after - before;
  const overflow = amount - actual;
  p.influence = after;
  const heroName = shortHeroName(p.hero);
  const tag = sourceName ? ` — ${sourceName}` : '';
  if (actual > 0) {
    state.log.add(`✨ ${heroName} [${p.name}]: +${actual} Влияния (${after}/${cap})${tag}`);
  }
  if (overflow > 0) {
    state.log.add(`✨ ${heroName} [${p.name}]: Влияние достигло максимума, +${overflow} не учтены${tag}`);
  }
  // Аура Второго директора зависит от Влияния — пересчёт.
  recomputeDirectorAura(state);
}

// Установить Влияние в конкретное значение (Манипуляция: → 0). Аура пересчитывается.
export function setInfluence(state, playerIdx, value) {
  const p = state.players[playerIdx];
  if (!p) return;
  const cap = INFLUENCE_MAX + (p.influenceMaxBonus || 0);
  p.influence = Math.max(0, Math.min(cap, value));
  recomputeDirectorAura(state);
}

// Списать стоимость карты Влияния. Возвращает true, если списание прошло, false иначе.
// А.4.4.2-fix2: единая точка списания — гарантирует пересчёт ауры и устраняет
// прямые мутации p.influence в каждой play*-функции.
export function chargeInfluence(state, playerIdx, cost) {
  const p = state.players[playerIdx];
  if (!p || cost <= 0) return false;
  if (p.influence < cost) return false;
  setInfluence(state, playerIdx, p.influence - cost);
  return true;
}
